/**
 * JINS Sunglasses SS26 — JavaScript
 * Vanilla JS (no jQuery dependency)
 * - Fade-in on scroll
 * - Smooth scroll for anchor links
 * - Custom scrollbar for sec01 horizontal scroll
 */

(function () {
  'use strict';

  /* ========================================
   * Fade-in on scroll
   * ======================================== */
  function fadeInCheck() {
    var elements = document.querySelectorAll('.jins-sg .fadein');
    var scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    var windowHeight = window.innerHeight;

    for (var i = 0; i < elements.length; i++) {
      var el = elements[i];
      var elemPos = el.getBoundingClientRect().top + scrollTop;

      if (scrollTop > elemPos - windowHeight + 100) {
        el.classList.add('show');
      }
    }
  }

  window.addEventListener('scroll', fadeInCheck);
  window.addEventListener('load', fadeInCheck);
  window.addEventListener('resize', fadeInCheck);

  /* ========================================
   * Smooth scroll for anchor links
   * ======================================== */
  document.addEventListener('click', function (e) {
    var link = e.target.closest('.jins-sg a[href^="#"]');
    if (!link) return;

    e.preventDefault();
    var href = link.getAttribute('href');
    var target = href === '#' || href === '' ? document.body : document.querySelector(href);

    if (target) {
      var position = target.getBoundingClientRect().top + window.pageYOffset;
      window.scrollTo({
        top: position,
        behavior: 'smooth'
      });
    }
  });

  /* ========================================
   * Custom scrollbar for horizontal scroll
   * ======================================== */
  function initScrollbars() {
    var scrollWraps = document.querySelectorAll('.jins-sg .scroll_wrap');

    scrollWraps.forEach(function (scrollWrap) {
      var thumb = scrollWrap.parentElement.querySelector('.scroll_thumb');
      if (!thumb) return;

      scrollWrap.addEventListener('scroll', function () {
        var scrollLeft = scrollWrap.scrollLeft;
        var maxScroll = scrollWrap.scrollWidth - scrollWrap.clientWidth;
        var barWidth = scrollWrap.parentElement.querySelector('.custom_scrollbar');

        if (maxScroll > 0 && barWidth) {
          var thumbWidth = (scrollWrap.clientWidth / scrollWrap.scrollWidth) * barWidth.clientWidth;
          var thumbPosition = (scrollLeft / maxScroll) * (barWidth.clientWidth - thumbWidth);

          thumb.style.width = thumbWidth + 'px';
          thumb.style.transform = 'translateX(' + thumbPosition + 'px)';
        }
      });

      // Trigger initial calculation
      scrollWrap.dispatchEvent(new Event('scroll'));
    });
  }

  window.addEventListener('load', initScrollbars);

  /* ========================================
   * Drag-to-scroll for desktop
   * ======================================== */
  function initDragScroll() {
    var scrollWraps = document.querySelectorAll('.jins-sg .scroll_wrap');

    scrollWraps.forEach(function (scrollWrap) {
      var isDown = false;
      var startX;
      var scrollLeft;
      var hasDragged = false;

      scrollWrap.addEventListener('mousedown', function (e) {
        isDown = true;
        hasDragged = false;
        scrollWrap.classList.add('is-dragging');
        startX = e.pageX - scrollWrap.offsetLeft;
        scrollLeft = scrollWrap.scrollLeft;
      });

      scrollWrap.addEventListener('mouseleave', function () {
        isDown = false;
        scrollWrap.classList.remove('is-dragging');
      });

      scrollWrap.addEventListener('mouseup', function () {
        isDown = false;
        scrollWrap.classList.remove('is-dragging');
      });

      scrollWrap.addEventListener('mousemove', function (e) {
        if (!isDown) return;
        e.preventDefault();
        var x = e.pageX - scrollWrap.offsetLeft;
        var walk = (x - startX) * 2;
        if (Math.abs(x - startX) > 5) hasDragged = true;
        scrollWrap.scrollLeft = scrollLeft - walk;
      });

      // Prevent click on links if user was dragging
      scrollWrap.addEventListener('click', function (e) {
        if (hasDragged) {
          e.preventDefault();
          e.stopPropagation();
          hasDragged = false;
        }
      }, true);
    });
  }

  window.addEventListener('load', initDragScroll);

  /* ========================================
   * Modal — slide-in product panel
   * ======================================== */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.jins-sg .btn_more_img');
    if (!btn) return;

    e.preventDefault();
    e.stopPropagation();

    var modalId = btn.dataset.modal;
    if (!modalId) return;
    var modal = document.getElementById(modalId);
    if (!modal) return;

    // Close any open modals first
    document.querySelectorAll('.jins-sg .img_modal.active').forEach(function (m) {
      m.classList.remove('active');
    });

    // Move modal to .jins-sg root so position:fixed isn't broken
    // by parent transforms (fadein translateY creates containing block)
    var root = document.querySelector('.jins-sg');
    if (modal.parentElement !== root) {
      root.appendChild(modal);
    }

    // Show modal
    modal.classList.add('active');

    // Add overlay
    var overlay = document.querySelector('.jins-sg .modal_overlay');
    if (!overlay) {
      overlay = document.createElement('div');
      overlay.className = 'modal_overlay';
      root.appendChild(overlay);
    }
    overlay.classList.add('active');
  });

  // Close modal — close button (bottom CLOSE and top-right X)
  document.addEventListener('click', function (e) {
    var closeBtn = e.target.closest('.jins-sg .close_modal, .jins-sg .close_modal_x');
    if (!closeBtn) return;

    e.stopPropagation();
    var modal = closeBtn.closest('.img_modal');
    if (modal) modal.classList.remove('active');

    var overlay = document.querySelector('.jins-sg .modal_overlay');
    if (overlay) overlay.classList.remove('active');
  });

  // Inject top-right X close button into all modals
  function initCloseX() {
    var modals = document.querySelectorAll('.jins-sg .modal_rel');
    modals.forEach(function (rel) {
      if (rel.querySelector('.close_modal_x')) return;
      var xBtn = document.createElement('button');
      xBtn.className = 'close_modal_x';
      xBtn.setAttribute('aria-label', 'Close');
      xBtn.textContent = '✕';
      rel.insertBefore(xBtn, rel.firstChild);
    });
  }

  window.addEventListener('load', initCloseX);

  // Close modal — click overlay
  document.addEventListener('click', function (e) {
    if (e.target.classList.contains('modal_overlay')) {
      document.querySelectorAll('.jins-sg .img_modal.active').forEach(function (m) {
        m.classList.remove('active');
      });
      e.target.classList.remove('active');
    }
  });
})();
